
import { observable, action, runInAction, } from 'mobx';
import { calculation, getJson, sum } from '@/method';
import { message } from 'antd';
import moment from 'moment';
import { dataDefault } from './data';

class store {
    @observable area = [];
    @observable interval = [];
    @observable date = moment().format('YYYY');
    @observable loading = true;
    @observable dataAll = {};

    getData = async () => {
        let area = JSON.parse(JSON.stringify(dataDefault));
        let interval = JSON.parse(JSON.stringify(dataDefault));

        const date = this.date;
        runInAction(() => {
            this.loading = true;
        });
        try {
            let res = await fetch(`/effectOcc?year=${moment(date).format('YYYY')}`, { credentials: 'include' });
            let x = await res.json();

            if (x.data.area && x.data.area.length > 0) {
                area = x.data.area.sort((a, b) => {
                    return a.sort - b.sort
                });
            }

            if (x.data.interval && x.data.interval.length > 0) {
                interval = x.data.interval.sort((a, b) => {
                    return a.sort - b.sort
                });
            }

            area = await this.computeNum(area, [
                x.data['东南华南'],
                x.data['华北华中'],
                x.data['江浙沪皖'],
                x.data['西南'],
            ]);

            interval = await this.computeNum(interval, [
                x.data['10'],
                x.data['9'],
                x.data['7'],
                x.data['6'],
                x.data['5'],
                x.data['4'],
                x.data['3'],
            ]);

            await runInAction(() => {
                this.area = area;
                this.interval = interval;
                this.loading = false;
                this.dataAll = x.data;
            });
            this.onSave();

        } catch (error) {
            console.error(error);
            message.error('获取数据失败');
            runInAction(() => {
                this.loading = false;
            });

        }
    }

    @action
    onSave = () => {

        let area = [...this.area].map(x => ({ ...x, year: this.date }));
        let interval = [...this.interval].map(x => ({ ...x, year: this.date }));

        let dataFrom = new FormData();
        dataFrom.append('area', JSON.stringify(area));
        dataFrom.append('interval', JSON.stringify(interval));

        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/effectOccAdd', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                message.success('保存成功！');
                return
            }
            message.error(x.msg);
        }).catch(err => {

            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    @action
    onChangeDate = (str) => {
        this.date = str;
        this.data = [];
        this.forecast = [];
        this.budget = [];
        this.getData();
    }

    @action
    computeNum = (data, list) => {

        list.forEach((item, i) => {
            const key = `space${i + 1}`;
            const num = sum([
                item['200<=Conference Area<500 <br/>200<=会议厅面积<500'],
                item['500<=Conference Area<1000 <br/>500<=会议厅面积<1000'],
                item['1000&lt;Conference Area<br/>1000&lt;会议厅面积'],
                item['Conference Area<200 <br/>会议厅面积<200'],
            ]);
            data[1][key] = calculation(
                item['Ballroom A <br/>多功能宴会厅A'],
                num, 4
            );
            data[2][key] = calculation(
                item['Ballroom B <br/>多功能宴会厅B'],
                num, 4
            );
            data[4][key] = calculation(
                item['Conference A <br/>大会议室A'],
                num, 4
            );
            data[5][key] = calculation(
                item['Conference B <br/>大会议室B'],
                num, 4
            );
            data[6][key] = calculation(
                item['Conference C<br/>大会议室C'],
                num, 4
            );
            data[7][key] = calculation(
                item['Conference D <br/>大会议室D'],
                num, 4
            );
            data[9][key] = calculation(
                item['Conference A<br/>中会议室A'],
                num, 4
            );
            data[10][key] = calculation(
                item['Conference B<br/>中会议室B'],
                num, 4
            );
            data[11][key] = calculation(
                item['Conference C <br/>中会议室C'],
                num, 4
            );
            data[12][key] = calculation(
                item['Conference D <br/>中会议室D'],
                num, 4
            );

            data[14][key] = calculation(
                item['Conference A<br/>小会议室A'],
                num, 4
            );
            data[15][key] = calculation(
                item['Conference B <br/>小会议室B'],
                num, 4
            );
            data[16][key] = calculation(
                item['Conference C<br/>小会议室C'],
                num, 4
            );
            data[17][key] = calculation(
                item['Conference D<br/>小会议室D'],
                num, 4
            );

            data[0][key] = sum([data[1][key], data[2][key]], 4);
            data[3][key] = sum([data[4][key], data[5][key], data[6][key], data[7][key]], 4);
            data[8][key] = sum([data[9][key], data[10][key], data[11][key], data[12][key]], 4);
            data[13][key] = sum([data[14][key], data[15][key], data[16][key], data[17][key]], 4);
        });

        return data
    }
}

const Actual = new store();

export default Actual;


// WEBPACK FOOTER //
// ./src/components/table/effect/1.2/store.js